<p-confirmDialog key="main" [style]="{ width: '400px' }" [baseZIndex]="10000"></p-confirmDialog>

<!--Menu Bar-->
<div class="lock-to-top" style="background-color: #ffffff">
	<!--Buttons-->
	<div class="button-body flex">
		<button class="btn btn-primary" style="margin-left: 0px" (click)="onRefresh()">Refresh</button>

		<!--INSERT CUSTOM BUTTONS HERE-->
		<button class="btn btn-primary" style="margin-left: 5px" (click)="onAddType()">Add Type</button>
		<button class="btn btn-primary" style="margin-left: 5px" (click)="onEditType()">Edit Type</button>
		<button class="btn btn-primary" style="margin-left: 5px" (click)="onDeleteType()">Delete Type</button>
	</div>
</div>

<!--Table-->
<div class="table-main-body">
	<p-table
		#mydt
		[value]="lstSchoolType"
		[loading]="loading"
		[paginator]="true"
		[(rows)]="pagerows"
		[(first)]="pagefirst"
		[showCurrentPageReport]="true"
		[resizableColumns]="false"
		sortMode="multiple"
		styleClass="p-datatable-striped"
		selectionMode="single"
		[(selection)]="SelectedSchoolType"
		dataKey="SchoolTypeID"
		(onFilter)="onHandleFilter($event)"
		(onSort)="onHandleSort($event)"
		(onRowSelect)="onRowSelect($event)"
		(onRowUnselect)="onRowUnselect($event)"
		currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries"
		[rowsPerPageOptions]="[5, 10, 25, 50]"
	>
		<!--Headers-->
		<ng-template pTemplate="header">
			<!--Filter or Select from Dropdown-->
			<tr>
				<!--INSERT CUSTOM FILTERS HERE-->

				<!--SchoolTypeCD-->
				<th>
					<p-columnFilter type="text" field="SchoolTypeCD" matchMode="contains" [showMenu]="true"></p-columnFilter>
				</th>

				<!--SchoolTypeDesc-->
				<th>
					<p-columnFilter type="text" field="SchoolTypeDesc" matchMode="contains" [showMenu]="true"></p-columnFilter>
				</th>

				<!--DefinedByDesc-->
				<th>
					<p-columnFilter field="DefinedByDesc" matchMode="equals" [showMenu]="false">
						<ng-template pTemplate="filter" let-value let-filter="filterCallback">
							<p-dropdown
								#filterDefinedByDesc
								[ngModel]="value"
								[options]="lstDefinedByDesc"
								(onChange)="filter($event.value)"
								placeholder="Any"
								[showClear]="true"
							>
								<ng-template let-value pTemplate="item">
									<span>{{ value }}</span>
								</ng-template>
							</p-dropdown>
						</ng-template>
					</p-columnFilter>
				</th>
			</tr>

			<!--Column Names-->
			<tr style="height: 4rem">
				<!--INSERT CUSTOM COLUMNS HERE-->
				<th pSortableColumn="SchoolTypeCD">Code<p-sortIcon field="SchoolTypeCD"></p-sortIcon></th>
				<th pSortableColumn="SchoolTypeDesc">Name<p-sortIcon field="SchoolTypeDesc"></p-sortIcon></th>
				<th pSortableColumn="DefinedByDesc">Defined By<p-sortIcon field="DefinedByDesc"></p-sortIcon></th>
			</tr>
		</ng-template>

		<!--Data-->
		<ng-template pTemplate="body" let-SchoolType>
			<tr [pSelectableRow]="SchoolType" (dblclick)="onRowDblClick(SchoolType)">
				<td *ngFor="let col of cols" style="font-weight: bold">
					{{ SchoolType[col.field] }}
				</td>
				<td
					style="font-weight: bold"
					[ngStyle]="{
						color: SchoolType['DefinedByDesc'] == 'System' || SchoolType['DefinedByDesc'] == 'Import' ? 'Red' : 'Black'
					}"
				>
					{{ SchoolType["DefinedByDesc"] }}
				</td>
			</tr>
		</ng-template>
	</p-table>
</div>

<!--Error Message-->
<div class="TopMargin">
	<div name="errorMessage" *ngIf="errorMessage" class="alert alert-danger">
		{{ errorMessage }}
	</div>
</div>
